export const getCleanStorageFileName = (url = '') => {
  if (!url) return '';

  try {
    const urlObj = new URL(url);
    const rawPath = decodeURIComponent(urlObj.pathname);
    const fileNameWithPrefix = rawPath.split('/').pop() || '';

    // Uploaded QC files follow: <type>_<timestamp>_<originalFileName>
    const cleanedName = fileNameWithPrefix.replace(/^[^_]+_\d+_/, '');

    return cleanedName || fileNameWithPrefix || url;
  } catch (error) {
    const decodedValue = decodeURIComponent(url);
    const fileNameWithPrefix = decodedValue.split('/').pop() || decodedValue;
    return fileNameWithPrefix.replace(/^[^_]+_\d+_/, '') || fileNameWithPrefix;
  }
};
